import { api } from '../../../lib/api'

export const UPGRADE_SUBSCRIPTION_REQUEST = 'UPGRADE_SUBSCRIPTION_REQUEST'
export const UPGRADE_SUBSCRIPTION_SUCCESS = 'UPGRADE_SUBSCRIPTION_SUCCESS'
export const UPGRADE_SUBSCRIPTION_FAILED = 'UPGRADE_SUBSCRIPTION_FAILED'

export const upgradeSubscription = function (currentSubscriptionId, toUpgradeSubscriptionId, onComplete) {
    return function (dispatch) {
        dispatch({
            type: UPGRADE_SUBSCRIPTION_REQUEST
        })
        api.upgradeSubscription(currentSubscriptionId, toUpgradeSubscriptionId).then(upgradeSubscriptionResponse => {
            dispatch({
                type: UPGRADE_SUBSCRIPTION_SUCCESS,
                payload: upgradeSubscriptionResponse
            })
            onComplete()
        }).catch(error => {
            dispatch({
                type: UPGRADE_SUBSCRIPTION_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/subscription/upgrade-subscription.js